export enum PhoneNumbersLabels {
  Support = '(844) 346-6038',
  StudentLoanSupport = '(216) 400-5775',
}

export enum PhoneNumbers {
  Support = '844-346-6038',
  StudentLoanSupport = '216-400-5775',
}
